import { BigDecimal } from "@solomon-labs/bigdecimal";

export function formatClaimAmount(atomic: string, decimals: number): string {
    return new BigDecimal(atomic)
        .divide(new BigDecimal(10).pow(decimals))
        .toFixed(decimals)
        .replace(/(\.\d*?[1-9])0+$|\.0+$/, "$1");
}
